import axios from "axios";

const POLL_INTERVAL_MS = 60 * 1000;

const state = {
    /** @type {Array<Object>} */
    notifications: [],
    /** @type {number} */
    unreadCount: 0,
    /** @type {boolean} */
    loading: false,
    /** @type {boolean} */
    panelOpen: false,
    /** @type {number|null} */
    pollTimerId: null,
};

const getters = {
    hasUnread: (state) => state.unreadCount > 0,
};

const mutations = {
    setNotifications(state, notifications) {
        state.notifications = notifications;
    },
    setUnreadCount(state, count) {
        state.unreadCount = count;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setPanelOpen(state, open) {
        state.panelOpen = open;
    },
    setPollTimerId(state, id) {
        state.pollTimerId = id;
    },
    markNotificationRead(state, notifId) {
        const n = state.notifications.find((x) => x.id === notifId);
        if (n && !n.is_read) {
            n.is_read = true;
            n.read_at = new Date().toISOString();
            state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
    },
    markAllRead(state) {
        state.notifications.forEach((n) => {
            n.is_read = true;
            n.read_at = n.read_at || new Date().toISOString();
        });
        state.unreadCount = 0;
    },
};

const actions = {
    async fetchUnreadCount({ commit }) {
        try {
            const { data } = await axios.get("/api/notifications/inapp/unread-count/");
            commit("setUnreadCount", data.count);
        } catch {
            // silent
        }
    },

    async fetchNotifications({ commit }) {
        commit("setLoading", true);
        try {
            const { data } = await axios.get("/api/notifications/inapp/?limit=30");
            commit("setNotifications", data.results || data);
        } catch {
            // silent
        } finally {
            commit("setLoading", false);
        }
    },

    async markRead({ commit }, notifId) {
        commit("markNotificationRead", notifId);
        try {
            await axios.post(`/api/notifications/inapp/${notifId}/mark-read/`);
        } catch {
            // silent
        }
    },

    async markAllRead({ commit }) {
        commit("markAllRead");
        try {
            await axios.post("/api/notifications/inapp/mark-all-read/");
        } catch {
            // silent
        }
    },

    togglePanel({ commit, state, dispatch }) {
        const willOpen = !state.panelOpen;
        commit("setPanelOpen", willOpen);
        if (willOpen) {
            dispatch("fetchNotifications");
        }
    },

    startPolling({ commit, dispatch, state }) {
        if (state.pollTimerId) return;
        dispatch("fetchUnreadCount");
        const id = setInterval(() => {
            dispatch("fetchUnreadCount");
        }, POLL_INTERVAL_MS);
        commit("setPollTimerId", id);
    },

    stopPolling({ commit, state }) {
        if (state.pollTimerId) {
            clearInterval(state.pollTimerId);
            commit("setPollTimerId", null);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
